import React, { useEffect, useState } from "react";
import CoreSpinner from "../../../../../app/core/components/CoreSpinner/CoreSpinner";
import { useNavigate } from "react-router-dom";
import CoreFolder from "../../../../../app/core/components/CoreFolder/CoreFolder";
import { Divider, Pagination, Stack, Tab, Tabs } from "@mui/material";
import { t } from "i18next";
import FolderSharedRoundedIcon from "@mui/icons-material/FolderSharedRounded";
import { useSelector } from "react-redux";

import FoldersButtonCockpit from "../ControlCockpit/FoldersButtonCockpit";
import CoreModal from "../../../../../app/core/components/CoreModal/CoreModal";
import CreateFolder from "./CreateFolder";
import {
  useGetFolderMacroQuery,
  useGetUsersFolderQuery,
} from "../../../../api/admin/adminFolders";
import { FOLDER_NUMBER } from "../../../../../utils/constants/tables";
import CoreSearchBar from "../../../../../app/core/components/CoreSearch/CoreSearch";

const GestioneDocumentiFolders = () => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const appConfig = useSelector((state) => state.app.appConfig);
  const navigate = useNavigate();
  const [selected, setSelected] = useState();
  const [modal, setModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: FOLDER_NUMBER,
  });

  const {
    data: listUser,
    isLoading: isListUserLoading,
    refetch,
  } = useGetUsersFolderQuery(
    {
      page,
      query: debouncedSearchTerm,
    },
    { skip: !appConfig.modules.documents.folders }
  );

  const { data: getMacrocatDoc, isLoading } = useGetFolderMacroQuery(
    selected?.id,
    {
      skip: !selected?.id,
    }
  );

  useEffect(() => {
    if (getMacrocatDoc) {
      navigate(`${selected.id}`, {
        state: {
          data: getMacrocatDoc,
          user: {
            id: selected?.id,
            name: `${selected?.name} ${selected?.surname}`,
          },
        },
      });
    }
  }, [getMacrocatDoc, navigate, selected]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 750);
    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  const handleGetMacrocat = (user) => {
    setSelected(user);
  };

  const handlePageChange = (event, value) => {
    setPage({
      currentPage: value,
      startRow: (value - 1) * FOLDER_NUMBER,
      endRow: value * FOLDER_NUMBER,
    });
    refetch();
  };

  const handleRefecthDocuments = () => {
    refetch();
  };

  if (!listUser || isListUserLoading) {
    return <CoreSpinner />;
  }

  return (
    <div>
      <div className="flex items-center">
        <h2 style={{ width: "200px" }}>{t("Archive")}</h2>
        <Tabs value={1}>
          <Tab
            className="text-mont text-capitalize fs-6"
            label={"Tabella"}
            onClick={() => navigate(-1)}
          />
          <Tab
            className="text-mont text-capitalize fs-6"
            label={t("Folders")}
          />
        </Tabs>
      </div>

      <div className="flex">
        <div className="w-2/3">
          <CoreSearchBar
            isLoading={isListUserLoading}
            placeholder={t("SearchDocExt")}
            searchTerm={searchTerm}
            handleChange={setSearchTerm}
          />
        </div>

        <FoldersButtonCockpit
          onRefecthDocuments={handleRefecthDocuments}
          onOpenModal={() => setModal(true)}
        />
      </div>
      <div className="flex flex-wrap pt-10">
        {listUser?.Data?.items?.map((el) => (
          <div className="p-4">
            <CoreFolder
              icon={
                <FolderSharedRoundedIcon
                  className="w-20 h-20"
                  style={{ color: colorPrimary }}
                />
              }
              onGetFolder={() => handleGetMacrocat(el)}
              nameFolder={`${el?.name} ${el?.surname}`}
            />
          </div>
        ))}
      </div>
      <Divider className="py-5" />
      <div className="w-full flex justify-center items-end ">
        <Stack spacing={2} className="mt-4">
          <Pagination
            count={Math.ceil(listUser?.Data.count / FOLDER_NUMBER) || 1}
            page={page.currentPage}
            onChange={handlePageChange}
            disabled={Math.ceil(listUser?.Data.count / FOLDER_NUMBER) === 1}
            sx={{
              "& .Mui-selected": {
                backgroundColor:
                  Math.ceil(listUser?.Data.count / FOLDER_NUMBER) === 1
                    ? ""
                    : `${colorPrimary} !important`,
                color: "#fff",
              },
            }}
          />
        </Stack>
      </div>
      <CoreModal
        width={"40%"}
        height={"40%"}
        onClose={() => setModal(false)}
        state={modal}
        component={<CreateFolder onClose={() => setModal(false)} />}
      />
    </div>
  );
};

export default GestioneDocumentiFolders;
